<template>
  <section class="section">
    <h1
      class="
        has-text-centered has-text-weight-bold
        subtitle
        is-size-4-mobile is-size-3-desktop
        pdx-small-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Which Sports Events are the Most Stressful to Watch?
    </h1>
    <h2
      class="
        has-text-centered
        subtitle
        is-size-6-mobile is-size-4-desktop
        pdx-large-desktop pdx-small-touch
        has-text-left-touch
      "
    >
      Major sporting events have us glued to our screens like nothing else!<br /><br />
      Coming as no surprise to anyone supporting England at this years Euro
      Championships, <strong>Euro 2020</strong> was the most stressful sporting
      event on the TV, with <strong>126,652 stressed tweets</strong> sent
      throughout the duration of the tournament.
    </h2>
    <chart-tab showType="Live Event"></chart-tab>
  </section>
</template>

<script>
import ChartTab from "@/components/ChartTab";
export default {
  components: { ChartTab },
};
</script>

<style lang="scss" scoped>
.section {
  background: linear-gradient(#d9edf6, #ffffff);
}
</style>
